import {useMemo, useState} from "react";

type UseCheckboxGroupOptions = {
	initialSelection?: string[];
};

type UseCheckboxGroup = [
	selectedItems: string[],
	{
		setSelectedItems: (selection: string[]) => void;
		toggleItem: (item: string) => void;
		resetItems: () => void;
	},
];

const useCheckboxGroup: (
	options?: UseCheckboxGroupOptions
) => UseCheckboxGroup = ({initialSelection = []} = {}) => {
	const [selectedItems, setSelectedItems] =
		useState<string[]>(initialSelection);

	const handlers = useMemo(
		() => ({
			setSelectedItems: (selection: string[]) => {
				setSelectedItems(selection);
			},
			toggleItem: (item: string) => {
				setSelectedItems((currentSelection) => {
					const itemIndex = currentSelection.indexOf(item);
					if (itemIndex < 0) {
						currentSelection.push(item);
					} else {
						currentSelection.splice(itemIndex, 1);
					}
					return currentSelection;
				});
			},
			resetItems: () => {
				setSelectedItems(initialSelection);
			},
		}),
		[initialSelection]
	);

	return [selectedItems, handlers];
};

export default useCheckboxGroup;
